<template>
    <div>
        <header class="fixed w-full bg-white/95 backdrop-blur-md z-50 border-b border-gray-100 transition-all duration-300">
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="flex justify-between items-center h-20">
                    
                    <a href="/" class="flex-shrink-0 flex items-center gap-2 cursor-pointer">
                        <img class="h-8" src="https://storage.victoranw.fr/file/hGf4I3ecnS" alt="logo termoflow">
                        <h1 class="font-extrabold text-2xl tracking-tight text-gray-900">Termoflow</h1>
                    </a>

                    <nav class="hidden md:flex space-x-8 items-center">
                        <a href="/" class="text-gray-600 hover:text-orange-600 font-medium transition-colors">Accueil</a>

                        <div class="relative group" @mouseleave="featuresOpen = false">
                            <button @click="featuresOpen = !featuresOpen" @mouseover="featuresOpen = true" class="text-gray-600 hover:text-orange-600 font-medium inline-flex items-center transition-colors py-2">
                                Fonctionnalités
                                <i class="fa-solid fa-chevron-down ml-1 text-xs transition-transform duration-200" :class="{'rotate-180': featuresOpen}"></i>
                            </button>
                            
                            <transition name="fade">
                                <div v-if="featuresOpen" class="absolute top-full left-1/2 transform -translate-x-1/2 mt-0 w-[700px] bg-white border border-gray-100 rounded-2xl shadow-xl p-6 z-50">
                                    <div class="grid grid-cols-2 gap-x-8 gap-y-2">
                                        <a :href="item.url" v-for="(item, index) in featureList" :key="index" class="flex items-center gap-3 p-2 rounded-lg hover:bg-orange-50 group transition-colors">
                                            <div class="w-8 h-8 rounded-lg bg-gray-50 text-gray-400 flex items-center justify-center group-hover:bg-white group-hover:shadow-sm transition-all">
                                                <i :class="item.icon" class="text-sm"></i>
                                            </div>
                                            <span class="text-sm font-medium text-gray-600">{{ item.name }}</span>
                                        </a>
                                    </div>
                                    <div class="mt-4 pt-4 border-t border-gray-100 text-center">
                                        <a href="/fonctionnalites" class="text-xs font-bold text-orange-600 hover:underline">Voir toutes les fonctionnalités <i class="fa-solid fa-arrow-right ml-1"></i></a>
                                    </div>
                                </div>
                            </transition>
                        </div>

                        <!-- Ressources dropdown -->
                        <div class="relative" @mouseleave="resourcesOpen = false">
                            <button @click="resourcesOpen = !resourcesOpen" @mouseover="resourcesOpen = true" class="text-gray-600 hover:text-orange-600 font-medium inline-flex items-center transition-colors py-2">
                                Ressources
                                <i class="fa-solid fa-chevron-down ml-1 text-xs transition-transform duration-200" :class="{'rotate-180': resourcesOpen}"></i>
                            </button>

                            <transition name="fade">
                                <div v-if="resourcesOpen" class="absolute top-full left-1/2 transform -translate-x-1/2 mt-0 w-64 bg-white border border-gray-100 rounded-2xl shadow-xl p-3 z-50">
                                    <a href="/roi/calculator" class="flex items-center gap-3 p-3 rounded-lg hover:bg-orange-50 group transition-colors">
                                        <div class="w-8 h-8 rounded-lg bg-gray-50 text-gray-400 flex items-center justify-center group-hover:bg-white group-hover:shadow-sm transition-all">
                                            <i class="fa-solid fa-calculator text-sm"></i>
                                        </div>
                                        <div>
                                            <span class="text-sm font-medium text-gray-700 block">Calculateur ROI</span>
                                            <span class="text-xs text-gray-400">Estimez vos économies</span>
                                        </div>
                                    </a>
                                    <a href="/blog" class="flex items-center gap-3 p-3 rounded-lg hover:bg-orange-50 group transition-colors">
                                        <div class="w-8 h-8 rounded-lg bg-gray-50 text-gray-400 flex items-center justify-center group-hover:bg-white group-hover:shadow-sm transition-all">
                                            <i class="fa-solid fa-newspaper text-sm"></i>
                                        </div>
                                        <div>
                                            <span class="text-sm font-medium text-gray-700 block">Blog</span>
                                            <span class="text-xs text-gray-400">Conseils & actualités</span>
                                        </div>
                                    </a>
                                </div>
                            </transition>
                        </div>

                        <a href="/tarifs" class="text-gray-600 hover:text-orange-600 font-medium transition-colors">Tarifs</a>
                        <a href="/contact" class="text-gray-600 hover:text-orange-600 font-medium transition-colors">Contact</a>
                    </nav>

                    <div class="hidden md:flex items-center space-x-6">
                        <!-- <template v-if="$account">
                            <a href="/dashboard" class="text-gray-900 font-semibold hover:text-orange-600 transition-colors">Tableau de bord</a>
                        </template>
                        <template v-if="!$account"> -->
                            <a href="/login" class="text-gray-900 font-semibold hover:text-orange-600 transition-colors">Connexion</a>
                            <a href="/register" class="bg-gradient-to-r from-orange-500 to-red-600 text-white px-6 py-2.5 rounded-full font-bold hover:shadow-lg hover:shadow-orange-500/40 transition-all duration-300 transform hover:-translate-y-0.5">
                                Essai gratuit
                            </a>
                        <!-- </template> -->
                    </div>

                    <div class="md:hidden">
                        <button @click="mobileMenuOpen = !mobileMenuOpen" class="text-gray-600 p-2">
                            <i class="fa-solid fa-bars text-2xl"></i>
                        </button>
                    </div>
                </div>
            </div>

            <transition name="slide-fade">
                <div v-if="mobileMenuOpen" class="md:hidden bg-white border-b border-gray-100 p-4 space-y-4 shadow-xl absolute w-full max-h-[90vh] overflow-y-auto">
                    <button @click="mobileMenuOpen = false" class="absolute top-4 right-4 w-10 h-10 flex items-center justify-center rounded-full bg-gradient-to-br from-orange-500 to-red-600 hover:from-orange-600 hover:to-red-700 shadow-lg hover:shadow-xl transition-all duration-200 group">
                        <i class="fas fa-times text-white text-lg group-hover:rotate-90 transition-transform duration-200"></i>
                    </button>
                    <div class="pt-10">
                        <a href="/" class="block text-gray-900 font-bold py-2 hover:text-orange-600 transition-colors">Accueil</a>
                    </div>
                    <div class="font-bold text-gray-900 px-2 mb-2">
                        <a href="/fonctionnalites" class="hover:text-orange-600 transition-colors">
                            Fonctionnalités
                        </a>
                    </div>
                    <div class="grid grid-cols-1 gap-2 pl-2 border-l-2 border-orange-100 ml-2 mb-4">
                        <a :href="item.url" v-for="(item, index) in featureList" :key="index" class="text-sm text-gray-600 py-1">{{ item.name }}</a>
                    </div>
                    <div class="font-bold text-gray-900 px-2 mb-2">Ressources</div>
                    <div class="grid grid-cols-1 gap-2 pl-2 border-l-2 border-orange-100 ml-2 mb-4">
                        <a href="/roi/calculator" class="text-sm text-gray-600 py-1">Calculateur ROI</a>
                        <a href="/blog" class="text-sm text-gray-600 py-1">Blog</a>
                    </div>
                    <a href="/tarifs" class="block text-gray-900 font-bold py-2 hover:text-orange-600 transition-colors">Tarifs</a>
                    <a href="/contact" class="block text-gray-900 font-bold py-2 hover:text-orange-600 transition-colors">Contact</a>
                    <div class="border-t border-gray-100 pt-4">
                        <a href="/login" class="block text-center text-gray-900 font-semibold py-3 rounded-xl border-2 border-gray-200 hover:border-orange-500 hover:text-orange-600 transition-all">
                            Connexion
                        </a>
                    </div>
                    <button @click="$router.push({name: 'LandingContact'})" class="w-full bg-gradient-to-r from-orange-500 to-red-600 text-white font-bold py-3 rounded-xl shadow-md">Demander une démo</button>
                </div>
            </transition>
        </header>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                mobileMenuOpen: false,
                featuresOpen: false,
                resourcesOpen: false,
                featureList: [
                    { name: 'Suivi des interventions', icon: 'fa-solid fa-calendar-check', url: '/interventions' },
                    { name: 'Application mobile métier', icon: 'fa-solid fa-mobile-screen-button', url: '/application-mobile' },
                    { name: 'CERFA & conformité', icon: 'fa-solid fa-file-signature', url: '/cerfa' },
                    { name: 'Gestion des clients', icon: 'fa-solid fa-handshake-angle', url: '/gestion-client' },
                    { name: 'Planification & tournées', icon: 'fa-solid fa-route', url: '/planification' },
                    // { name: 'Appareils & documentations', icon: 'fa-solid fa-book-open', url: '/appareils-documentation' },
                    { name: 'Gestion du stock', icon: 'fa-solid fa-boxes-stacked', url: '/stock' },
                    { name: 'Bouteilles de gaz & fluides', icon: 'fa-solid fa-flask', url: '/bouteilles' },
                    { name: 'Détecteurs de gaz', icon: 'fa-solid fa-mobile-retro', url: '/detecteurs' },
                    { name: 'Contrats d\'entretien', icon: 'fa-solid fa-file-contract', url: '/contrats-entretien' },
                    { name: 'Portail client', icon: 'fa-solid fa-users-viewfinder', url: '/portail-client' },
                    { name: 'Communication automatisée', icon: 'fa-solid fa-envelope-open-text', url: '/communication-automatisee' },
                    { name: 'Statistiques & pilotage', icon: 'fa-solid fa-chart-pie', url: '/statistiques' },
                    { name: 'Exports & reporting', icon: 'fa-solid fa-file-export', url: '/exportation-donnees' },
                    { name: 'Intégrations', icon: 'fa-solid fa-plug', url: '/integration' },
                ]
            }
        },
        methods: {
            toggleMobileMenu() {
                this.mobileMenuOpen = !this.mobileMenuOpen;
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>